import { defineComponent, PropType } from "vue";
import { Container } from "aurelia-dependency-injection";

import {  IImmunizationRecord, PatientService } from "../../../../../../../services/patient.service";
import { Immunization } from "../../../../../../../models/pal-health-history/immunzation.model";
import { IGetImmuizationDeclineValueSet } from "../../../../../../../services/lookup-service";
import { formatDate } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { EnumMap } from "../../../../../../../common/enum-map";
import { ToastrService } from "../../../../../../../services/toastr.service";
import { HttpStatusCodeEnum } from "../../../../../../../common/http-status-code-enum";

import TablePrompt from "../../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import VaccineRecordForm from "../VaccineRecordForm/VaccineRecordForm.vue";
import DeclinedVaccineForm from "../DeclinedVaccineForm/DeclinedVaccineForm.vue";
import FormSection from "../../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import EmptyTextHandler from "../../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";

export default defineComponent({
    components:{
       TablePrompt,
       VaccineRecordForm,
       DeclinedVaccineForm,
       FormSection,
       EmptyTextHandler
    },

    props: {
        immunization: {
            type:Object as PropType<IImmunizationRecord>
        },
        declinedValueSet:{
            type:Array<IGetImmuizationDeclineValueSet>
        },
        columns:{
            type:Number
        },
        pageReset:{
            type:Function
        },
        patientId:{
            type:String
        },
        statusEnumMap:{
            type:EnumMap
        },
        typeOfRecordEnumMap:{
            type:EnumMap
        },
        typeOfRecordEnum:{
            type:Array
        },
        immunizationStatusEnum:{
            type:Array
        },
        accountId:{
            type:String
        },
        application:{
            type:Number
        }
    },
    data(vm) {
        return{
            _toastrService:null,
            _patientsService:null,
            isEditRequested:false as boolean,
            isViewDetailsRequested:false as boolean,
            isDeleteRequested:false as boolean,
            cacheImmunization: null as Immunization ,
            isDeleteInProgress:false as boolean,
            isEditInProgress:false as boolean,
            formatDate
        }
    },

    created() {
        this._patientsService = Container.instance.get(PatientService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    methods:{
        getReasonNotPerformed(reason: string) {
            if (!reason) {
                return "";
            }
            reason = reason.charAt(0).toUpperCase() + reason.slice(1);
            return reason;
        },
         openEditImmunization() {
            if (this.statusEnumMap.checkEnumValue("Declined", this.immunization.Status)) {
                this.cacheImmunization = new Immunization(this.immunization);
            } else {
                this.cacheImmunization = new Immunization(this.immunization);
            }
            this.isEditRequested = true;
        },
        openDeleteRequest() {
            this.isDeleteRequested = true;
        },


    openViewDetails() {
        if (this.statusEnumMap.checkEnumValue("Declined", this.immunization.Status)) {
            this.cacheImmunization = new Immunization(this.immunization);
        } else {
            this.cacheImmunization = new Immunization(this.immunization);
        }
        this.isViewDetailsRequested = true;
    },

    closeDeleteRequest() {
        this.isDeleteRequested = false;
    },

    async deleteImmunization() {
        try {
            this.isDeleteInProgress = true;
            const payload = {
                accountId:this.accountId,
                application:this.application
            }
            await this._patientsService.deleteVaccineRecord(this.patientId, this.immunization.Id,payload);
            this.pageReset();
            this._toastrService.success({
                title: "Record of Vaccine Administration Deleted",
                message: "Record of Vaccine Administration has been successfully deleted"
            });
        } catch (err) {
            console.error(err);
            this._toastrService.error({
                title: "Error - Record of Vaccine Administration",
                message: "There was an error deleting Record of Vaccine Administration. Please try again."
            });
        } finally {
            this.isDeleteInProgress = false;
        }
    },
     cancelViewDetails() {
        this.isViewDetailsRequested = false;
    },

    async editImmunization() {
        let isFormValid=false;
        if(this.statusEnumMap.checkEnumValue('Declined', this.immunization.Status)){
           isFormValid=await (this.$refs.declinedForm as any).v$.$validate()
        }else{
            isFormValid=await (this.$refs.vaccineForm as any).v$.$validate()
        }
        if(isFormValid){
        try {
            this.isEditInProgress = true;
            const payload = {
                Application:this.application,
                AccountId:this.accountId,
                PalliativePatientImmunization:this.cacheImmunization
            }
            await this._patientsService.updateVaccineRecord(this.patientId,this.immunization.Id,payload);
            this.cancelEditImmunization();
            this.pageReset();
            this._toastrService.success({
                title: "Record of Vaccine Administration Updated",
                message: "Record of Vaccine Administration has been successfully updated"
            });
        } catch (err) {
            console.error(err);
            if (err.status === HttpStatusCodeEnum.NotModified) {
                this._toastrService.info({
                    title: `No Changes Detected`,
                    message: `There were no changes made to the Record of Vaccine Administration.`
                });
            } else {
                this._toastrService.error({
                    title: "Error - Record of Vaccine Administration",
                    message: "There was an error updating Record of Vaccine Administration. Please try again."
                });
            }
        } finally {
            this.isEditInProgress = false;
        }
    }else{
        this._toastrService.error({
            title: "Error -Vaccine Form",
            message: "Please fill required fields"
        });
    }
    },

   cancelEditImmunization() {
        this.isEditRequested = false;
    }

    }
});
